<template>
  <div class="dbct" v-if="strategyType == 'typeStrategieBagageType' && response != null">
    <article class="ov-card dbct__ticket">
      <!-- Bandeau : titre + impression -->
      <div class="dbct__strip">
        <div class="dbct__strip-main">
          <span class="dbct__strip-icon"><v-icon small>mdi-bag-suitcase</v-icon></span>
          <div>
            <div class="dbct__strip-kicker">Stratégie : Type</div>
            <div class="dbct__strip-title">Détail du billet de bagage</div>
          </div>
        </div>
        <button type="button" class="ov-btn ov-btn--sm dbct__print" @click="printTicket" :disabled="isPrinting">
          <v-progress-circular v-if="isPrinting" indeterminate size="14" width="2"></v-progress-circular>
          <v-icon v-else small>mdi-printer-outline</v-icon>
          {{ isPrinting ? 'Génération...' : 'Imprimer le billet' }}
        </button>
      </div>

      <!-- Zone imprimable -->
      <div id="dbct-print-area">
        <!-- En-tête visible uniquement à l'impression -->
        <div class="dbct-print-header">
          <div class="dbct-print-header__logo">AfricanB</div>
          <div class="dbct-print-header__title">BILLET DE BAGAGE</div>
          <div class="dbct-print-header__meta">Stratégie : Type &bull; {{ new Date().toLocaleDateString('fr-FR') }}</div>
        </div>

        <!-- Client + Voyage -->
        <div class="dbct__section dbct__grid">
          <div>
            <div class="dbct__group-title">
              <v-icon small>mdi-account-outline</v-icon>
              Informations client
            </div>
            <div class="ov-row dbct__fields">
              <div class="dbct__item">
                <div class="dbct__label">Nom</div>
                <div class="dbct__value">{{ clientInfo.nom || '-' }}</div>
              </div>
              <div class="dbct__item">
                <div class="dbct__label">Prénom(s)</div>
                <div class="dbct__value">{{ clientInfo.prenoms || '-' }}</div>
              </div>
              <div class="dbct__item ov-col-full">
                <div class="dbct__label">E-mail</div>
                <div class="dbct__value">{{ clientInfo.email || '-' }}</div>
              </div>
              <div class="dbct__item">
                <div class="dbct__label">Téléphone</div>
                <div class="dbct__value">{{ clientInfo.telephone || '-' }}</div>
              </div>
              <div class="dbct__item">
                <div class="dbct__label">Adresse</div>
                <div class="dbct__value">{{ clientInfo.adress || '-' }}</div>
              </div>
            </div>
          </div>

          <div>
            <div class="dbct__group-title">
              <v-icon small>mdi-bus</v-icon>
              Informations voyage
            </div>
            <div class="ov-row dbct__fields">
              <div class="dbct__item ov-col-full">
                <div class="dbct__label">Programme</div>
                <div class="dbct__value">{{ ticketInfo.programmeDesignation || '-' }}</div>
              </div>
              <div class="dbct__item ov-col-full">
                <div class="dbct__label">Offre de voyage</div>
                <div class="dbct__value">{{ ticketInfo.offreVoyageDesignation || '-' }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Perforation -->
        <div class="dbct__perf" aria-hidden="true"><span class="dbct__perf-line"></span></div>

        <!-- Résumé + Bagages -->
        <div class="dbct__section">
          <div class="dbct__group-title">
            <v-icon small>mdi-bag-checked</v-icon>
            Résumé des bagages
          </div>
          <div class="dbct__stats dbct__stats--2">
            <div class="dbct__stat">
              <div class="dbct__label">Montant à payer</div>
              <div class="dbct__stat-value dbct__stat-value--accent">{{ response.montantSoldable.toLocaleString('fr-FR') }}<small>FCFA</small></div>
            </div>
            <div class="dbct__stat">
              <div class="dbct__label">Total bagages</div>
              <div class="dbct__stat-value">{{ response.bagageTypeDTO.bagageTypeReferenceDTOS.length }}</div>
            </div>
          </div>

          <div class="dbct__bags-title">Liste des bagages</div>
          <div v-if="groupedBags.length > 0" class="dbct__bags">
            <span v-for="(item, index) in groupedBags" :key="index" class="ov-badge ov-badge--navy ov-badge--plain">
              <v-icon x-small>mdi-bag-suitcase-outline</v-icon>
              {{ item.type }}
              <strong>× {{ item.count }}</strong>
            </span>
          </div>
          <div v-else class="ov-empty dbct__empty">
            <v-icon small color="#94a3b8">mdi-bag-suitcase-off</v-icon>
            Aucun bagage enregistré
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import axios from 'axios';
import { API_GENERATE_BAGAGE_RECEIPT, HEADERS } from '@/components/globalConfig/globalConstConfig';

export default {
  name: "DetailBagageClientType",
  props: ["response", "strategyType", "ticketReference"],
  data() { return { isPrinting: false }; },
  computed: {
    clientInfo() {
      const ticket = this.$store.state.ticket;
      return (ticket && ticket.clientDetails) ? ticket.clientDetails : {};
    },
    ticketInfo() {
      return this.$store.state.ticket || {};
    },
    // Grouper les bagages par type avec compteur
    groupedBags() {
      if (!this.response || !this.response.bagageTypeDTO || !this.response.bagageTypeDTO.bagageTypeReferenceDTOS) {
        return [];
      }
      
      const grouped = {};
      this.response.bagageTypeDTO.bagageTypeReferenceDTOS.forEach(bag => {
        const type = bag.typeBagageDesignation;
        if (grouped[type]) {
          grouped[type]++;
        } else {
          grouped[type] = 1;
        }
      });
      
      return Object.entries(grouped).map(([type, count]) => ({
        type,
        count
      }));
    },
  },
  methods: {
    async printTicket() {
      const reference = this.ticketReference
        || this.ticketInfo.reservationBilletReference
        || this.ticketInfo.designation;
      if (!reference) {
        console.error('Référence billet introuvable');
        return;
      }
      this.isPrinting = true;
      try {
        const response = await axios.post(
          API_GENERATE_BAGAGE_RECEIPT,
          { data: { reservationBilletReference: reference } },
          {
            headers: HEADERS(this.$store.state.userAuthentified.token),
            responseType: 'blob',
          }
        );
        const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.download = `recu-bagage-${reference}.pdf`;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => URL.revokeObjectURL(url), 15000);
      } catch (e) {
        console.error('Erreur génération reçu bagage:', e);
      } finally {
        this.isPrinting = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../../styles/admin/ui";

/* ===== BILLET DE BAGAGE ===== */
.dbct__strip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px 22px;
  background: $ov-navy;
  color: #ffffff;
}

.dbct__strip-main {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.dbct__strip-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.12);

  .v-icon {
    color: #ffffff !important;
  }
}

.dbct__strip-kicker {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.7);
}

.dbct__strip-title {
  font-size: 17px;
  font-weight: 900;
}

.dbct__print {
  color: $ov-navy;
  background: #ffffff;

  &:hover:not(:disabled) {
    color: $ov-green;
  }
}

.dbct-print-header {
  display: none;
}

.dbct__section {
  padding: 22px;
}

.dbct__grid {
  display: grid;
  grid-template-columns: minmax(0, 3fr) minmax(0, 2fr);
  gap: 28px;
}

.dbct__group-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: $ov-green;

  .v-icon {
    color: $ov-green !important;
  }
}

.dbct__fields {
  row-gap: 14px;
}

.dbct__item {
  min-width: 0;
}

.dbct__label {
  margin-bottom: 4px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: $ov-subtle;
}

.dbct__value {
  font-size: 14px;
  font-weight: 700;
  color: $ov-navy;
  word-break: break-word;
}

/* Perforation : ligne pointillée + deux encoches */
.dbct__perf {
  position: relative;
  height: 24px;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: $ov-soft;
    border: 1px solid $ov-line;
  }

  &::before {
    left: -13px;
  }

  &::after {
    right: -13px;
  }
}

.dbct__perf-line {
  position: absolute;
  top: 50%;
  left: 22px;
  right: 22px;
  border-top: 2px dashed rgba(15, 23, 42, 0.15);
}

/* Résumé */
.dbct__stats {
  display: grid;
  gap: 12px;
  margin-bottom: 20px;

  &--2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  &--3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.dbct__stat {
  padding: 14px 16px;
  border: 1px solid $ov-line;
  border-radius: 12px;
  background: $ov-soft;
}

.dbct__stat-value {
  font-size: 20px;
  font-weight: 900;
  line-height: 1.2;
  color: $ov-navy;

  &--accent {
    color: $ov-green;
  }

  small {
    margin-left: 4px;
    font-size: 11px;
    font-weight: 700;
    color: $ov-subtle;
  }
}

.dbct__bags-title {
  margin-bottom: 10px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: $ov-muted;
}

.dbct__bags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  .v-icon {
    color: inherit !important;
  }
}

.dbct__empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 18px;
}

@media (max-width: 900px) {
  .dbct__grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 600px) {
  .dbct__stats--2,
  .dbct__stats--3 {
    grid-template-columns: 1fr;
  }
}

/* ===== IMPRESSION ===== */
@media print {
  body * { visibility: hidden !important; }
  #dbct-print-area, #dbct-print-area * { visibility: visible !important; }
  #dbct-print-area { position: fixed; left: 0; top: 0; width: 100%; padding: 24px; background: white; }
  .dbct-print-header { display: block !important; text-align: center; margin-bottom: 20px; padding-bottom: 14px; border-bottom: 2px solid $ov-green; }
  .dbct-print-header__logo { font-size: 11px; font-weight: 700; color: $ov-subtle; text-transform: uppercase; letter-spacing: 0.1em; }
  .dbct-print-header__title { font-size: 22px; font-weight: 900; color: $ov-ink; margin: 4px 0; }
  .dbct-print-header__meta { font-size: 12px; color: $ov-muted; }
  .dbct__grid { grid-template-columns: 1fr 1fr !important; }
  .dbct__perf { display: none; }
}
</style>
